import {
  Popover,
  Box,
  Divider,
  Paper,
  Typography,
  useTheme,
  Backdrop,
} from "@mui/material";
import * as React from "react";

import { useNavigation } from "@/providers";

import { CreateDatasetForm } from "../CreateDatasetForm";

interface CreateDatasetPopoverProps {
  anchorEl: HTMLElement | null;
  handleClose?: () => void;
}

export const CreateDatasetPopover: React.FC<CreateDatasetPopoverProps> = (
  props,
) => {
  const theme = useTheme();
  const { goto } = useNavigation();

  return (
    <>
      <Popover
        id={"popover-create-dataset"}
        open={Boolean(props.anchorEl)}
        anchorEl={props.anchorEl}
        onClose={props.handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: -15,
          horizontal: "center",
        }}
        marginThreshold={5}
      >
        <Box
          component={Paper}
          elevation={24}
          sx={{
            width: "30rem",
            padding: theme.spacing(1.5),
          }}
        >
          <Typography variant="subtitle1">New Dataset</Typography>
          <Divider sx={{ mt: theme.spacing(1), mb: theme.spacing(1) }} />
          <CreateDatasetForm
            onSuccess={(dataset) => {
              props.handleClose?.();
              goto.dataset({ datasetId: dataset.dataset_id });
            }}
          />
        </Box>
      </Popover>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: theme.zIndex.modal,
          display: props.anchorEl ? "block" : "none",
        }}
        open={Boolean(props.anchorEl)}
        onClick={props.handleClose}
      />
    </>
  );
};
